module.exports = __webpack_public_path__ + "static/media/renshibankuai.12c46128.png";